import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Button,
  IconButton,
  TextField,
  Autocomplete,
  Divider,
} from '@mui/material';
import { Add, Edit } from '@mui/icons-material';
import UserSelectModal from './UserSearchModal';
import DateFilter from './DateFilter';

export default function AddPosition({
  buttonText,
  positions,
  onAdd,
  committeeId,
  isSaving,
  savingError,
  saveSuccess,
  spdChapterId,
  localChapterId,
}) {
  const [error, setError] = useState(null);
  const [sentToSave, setSentToSave] = useState(false);
  const [positionSelected, setPositionSelected] = useState(null);
  const [showUserSelect, setShowUserSelect] = useState(false);
  const [userSelected, setUserSelected] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [addingPosition, setAddingPosition] = useState(false);
  const [userName, setUserName] = useState(null);

  const resetState = () => {
    setError(null);
    setSentToSave(false);
    setPositionSelected(null);
    setShowUserSelect(false);
    setUserSelected(null);
    setStartDate(null);
    setAddingPosition(false);
    setUserName(null);
  };
  useEffect(() => {
    if (savingError) {
      setError(savingError);
      setSentToSave(false);
    }
    if (isSaving) {
      setError(null);
    }
  }, [isSaving, savingError]);

  useEffect(() => {
    if (sentToSave && !isSaving && !savingError) {
      resetState();
    }
  }, [isSaving, savingError, sentToSave]);

  const handleAddPosition = () => {
    setAddingPosition(true);
    setShowUserSelect(true);
    if (positions.length === 1) {
      setPositionSelected(positions[0].id);
    }
  };

  const handleUserSelect = (user) => {
    let userId = user.id;
    let userName = user.full_name;
    setUserSelected(userId);
    setUserName(userName);
    setShowUserSelect(false);
  };

  const handleSave = () => {
    // validate then call function passed in
    if (!userSelected) {
      setError('Please select a user');
      return;
    }
    if (!positionSelected) {
      setError('Please select a position');
      return;
    }
    if (!startDate) {
      setError('Please select a start date');
      return;
    }
    setError(null);
    setSentToSave(true);
    onAdd({
      action: 'newAppointment',
      userId: userSelected,
      positionId: positionSelected,
      committeeId: committeeId,
      startDate: startDate,
    });
  };

  const handleUpdatePosition = (position) => {
    setPositionSelected(position.id);
  };

  return (
    <Grid container>
      {!addingPosition ? (
        <Grid item xs={12} textAlign={'center'}>
          <Button
            variant="contained"
            color="green"
            onClick={() => handleAddPosition()}
            size="small"
            disabled={isSaving || !positions || positions.length === 0}
            sx={{
              fontWeight: 'bold',
            }}
          >
            <Add sx={{ fontSize: 17, pr: 1 }} />
            {buttonText}
          </Button>
        </Grid>
      ) : (
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1">
              {userName ? userName : 'Please select a user'}
              <IconButton
                onClick={() => {
                  setShowUserSelect(true);
                }}
                sx={{ padding: 0, marginLeft: 1 }}
              >
                <Edit fontSize="small" color="blue" sx={{ fontSize: 18 }} />
              </IconButton>
            </Typography>
          </Grid>
          <Grid item xs={12} paddingTop paddingBottom>
            <Autocomplete
              size={'small'}
              onChange={(event, newValue) => handleUpdatePosition(newValue)}
              getOptionLabel={(option) => option.name}
              variant="standard"
              value={
                positions.find((option) => option.id === positionSelected)
                  ? positions.find((option) => option.id === positionSelected)
                  : null
              }
              label={'Position'}
              options={positions}
              renderInput={(params) => (
                <TextField {...params} label={'Position'} />
              )}
            />
          </Grid>
          <Grid item xs={12} paddingTop paddingBottom>
            <DateFilter
              filterValue={startDate}
              updateFilters={setStartDate}
              label={'Start Date'}
            />
          </Grid>
          <Grid item xs={12} paddingBottom>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => {
                handleSave();
              }}
              disabled={sentToSave}
              sx={{ fontWeight: 'bold' }}
            >
              Save
            </Button>
            <Button
              variant="contained"
              color="warning"
              size="small"
              onClick={() => {
                resetState();
              }}
              disabled={sentToSave}
              sx={{ fontWeight: 'bold', marginLeft: 1 }}
            >
              Cancel
            </Button>
          </Grid>
          {error && (
            <Grid item xs={12} paddingBottom>
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            </Grid>
          )}
        </Grid>
      )}

      <UserSelectModal
        modalOpen={showUserSelect}
        setModalOpen={setShowUserSelect}
        setUser={handleUserSelect}
        allowSetToMe={false}
        userObjectRet={true}
        chapter={localChapterId}
        spd={spdChapterId}
      />
    </Grid>
  );
}
